import { render, staticRenderFns } from "./MartzIcons.vue?vue&type=template&id=795fe762&scoped=true&"
import script from "./MartzIcons.vue?vue&type=script&lang=js&"
export * from "./MartzIcons.vue?vue&type=script&lang=js&"
import style0 from "./MartzIcons.vue?vue&type=style&index=0&id=795fe762&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795fe762",
  null
  
)

export default component.exports